import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();


export function  hasProp (obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  }
